import { useCallback, useEffect, useState } from "react";
import { getQuietHoursData } from "../api";

export const useIsQuietHours = ({
  subscriptionId,
  subscriptionConfigToken,
}: {
  subscriptionId?: string | null | undefined;
  subscriptionConfigToken?: string | null | undefined;
}) => {
  const [isQuietHours, setIsQuietHours] = useState(false);
  const [formattedQuietHours, setFormattedQuietHours] = useState("");

  const checkQuietHours = useCallback(async () => {
    if (subscriptionId && subscriptionConfigToken) {
      const data = await getQuietHoursData(subscriptionId, subscriptionConfigToken);
      setIsQuietHours(data.isQuietHours);
      setFormattedQuietHours(data.formattedQuietHours);
    }
  }, [subscriptionId, subscriptionConfigToken]);
  useEffect(() => {
    // check on load
    checkQuietHours();
  }, [checkQuietHours, subscriptionId, subscriptionConfigToken]);

  useEffect(() => {
    // check every minute
    const interval = setInterval(() => {
      checkQuietHours();
    }, 60000);
    return () => {
      clearInterval(interval);
    };
  }, [checkQuietHours]);

  return { isQuietHours, formattedQuietHours };
};
